import Promise from "bluebird"
import moment from "moment"
import axios from "axios"
import HttpService from "./http.service"

const REQ = process.env.VUE_APP_API_REQ

const AGENDA = process.env.VUE_APP_AGENDA
const CLUB_RESULTS = process.env.VUE_APP_RESULTS_CLUB
//const TEAM_RESULTS = process.env.VUE_APP_RESULTS_TEAM
//const RANKING = process.env.VUE_APP_RANKING
const CALENDAR = process.env.VUE_APP_CALENDAR

const AGENDA_API = REQ + "?value=" + encodeURIComponent(AGENDA)
const CLUB_RESULTS_API = REQ + "?value=" + encodeURIComponent(CLUB_RESULTS)
const READ_API = REQ + "?value="
//const TEAM_RESULTS_API = REQ + "?value="
//const RANKING_API = REQ + "?value="
//const CALENDAR_API = REQ + "?value="

class EventService {
  
  static NUMBERS = process.env.VUE_APP_API_NUMBERS

  static COLORAT = process.env.VUE_APP_API_COLORAT

  static MONTHS = ["", "janvier", "fevrier", "mars", "avril", "mai", "juin", "juillet", "août", "septembre", "octobre", "novembre", "decembre"]

  static EVENTS = {
    "regional-2" : "R2",
    "premiere-division": "D1",
    "quatrieme-division": "D4",
    "troisieme-division": "D3",
    "cinquieme-division": "D5",
    "departemental-5": "D5",
    "1-ere-phase-u-19-1-ere-div": "D1",
    "1-ere-phase-u-17-1-ere-div": "D1",
    "1-ere-phase-u-15-1-ere-div": "D1",
    "1-ere-phase-u-15-3-eme-div": "D3",
    "coupe-de-france" : "ligue",
    "coupe-des-reserves-1": "district",
    "gambardella-credit-agricole": "ligue",
    "challenge-anjou-seniors-1": "district",
    "challenge-hubert-sourice-1": "district"
  }

  static LOGOS = {
    "ligue": "https://www.asspm.fr/lab/data/apps/asspm/images/coupe2france32x32.png",
    "district": "https://www.asspm.fr/lab/data/apps/asspm/images/district-v2.jpg"
  }

  static parser = new DOMParser();
  
  static _numbers = []

  static init() {
    return this.getNumbers()
  }

  static read(api) {
    console.log("READ", api);
    //return Promise.resolve(axios.get(api + "&cache=no"))
    return Promise.resolve(axios.get(api))
  }
  
  static getAgenda() {
/*
    return this.read(AGENDA_API)
*/
    let read = "agenda"
    console.log("READ AGENDA", read);
    return this.read(READ_API + read)
      .get("data")
      .then(data => this.parseResult("AGENDA", data))
  }

  static getTeams() {
    let read = "teams"
    console.log("READ TEAMS", read);
    return this.read(READ_API + read)
      .get("data")
  }

  static getTeamResults(event) {
    //let read = this.getUrl(TEAM_RESULTS, event)
    let read = "resultat-" + event.competition
    console.log("READ TEAM RESULTS", read);
    return this.read(READ_API + read)
      .get("data")
      .then(data => this.parseResult("TEAM_RESULT", data, read))
      .tap(teamResults => {
        console.log(read, teamResults)
      })
  }
  
  static getClubResults() {
    //return this.read(CLUB_RESULTS_API)
    let read = "resultats"
    console.log("READ RESULTATS", read);
    return this.read(READ_API + read)
      .get("data")
      .then(data => this.parseResult("CLUB_RESULT", data))
  }
  
  static getCalendarUrl(event) {
    return this.getUrl(CALENDAR, event)    
  }
  
  static getCalendar(event) {
    //let read = CALENDAR_API + this.getUrl(CALENDAR, event).replace(/&/g, "%26")
    let read = READ_API + "calendar-" + event.competition
    console.log("READ CALENDAR", read);
    return this.read(read)
      .get("data")
      .then(r => EventService.parseResult("CALENDAR", r))
  }

  static getUrl(url, event) {
    if (!event) return ""
    _.forOwn(event, (v, k) => url = url.replace(new RegExp(`{${k}}`), v))
    if (event.label === "COUPE%20DE%20FRANCE") url = url.replace(/label_group/, "label")
    return url
  }

  static getRanking(event) {
    /* exit if district or ligue*/
    let eventKey = _.kebabCase(event.label.replace(/%20/g, "-"))
    let e = _.get(this.EVENTS, eventKey, eventKey)
    if (e === "district" || e === "ligue") return Promise.resolve([]);

    //let read = this.getUrl(RANKING, event)
    let read = "ranking-" + event.competition
    //console.log("READ RANKING", read);
    const readDecode = decodeURIComponent(read)
    console.log("READ RANKING", readDecode);
    /*
    https://foot49.fff.fr/recherche-clubs/?scl=21149&tab=resultats&subtab=ranking&competition=365366&stage=1&group=7&label=QUATRIEME%20DIVISION
    */
    return Promise.resolve(this.read(READ_API + readDecode.replace(/&/g, "%26")))
      .get("data")
      .then(html => {
        //debugger
        //EventService.parseResult(r)
        const doc = this.parser.parseFromString(html, "text/html");
        const query = doc.body.querySelectorAll(`.ranking-tab tr`)
        const ranks = _.map(query, q => {
          const doc = this.parser.parseFromString(`<table><tr>${q.innerHTML}</tr></table>`, "text/html");
          const cells = _.map(doc.body.querySelectorAll(`td`), "textContent")
          const rank = {
            pl: cells[0],
            eq: this.parseTeam(cells[1]),
            pts: cells[2],
            jo: cells[3],
            g: cells[4],
            n: cells[5],
            p: cells[6],
            f: cells[7],
            bp: cells[8],
            bc: cells[9],
            pe: cells[10],
            dif: cells[11],
            event: event
          }
          return rank
        })
        return ranks;
      })
  }
  
  static getNumbers() {
    return Promise.resolve(axios.get(this.NUMBERS))
      .then(result => this._numbers = result.data)
  }

  static parseMonth(month) {
    return _.padStart(_.indexOf(this.MONTHS, _.kebabCase(month)), 2, "0")
  }

  static parseDate(value) {
    const frag = value.split(" ");
    const day = frag[1]
    const month = this.parseMonth(frag[2])
    const year = frag[3]
    const hour = frag[5]
    const order = "" + year + month + day + hour
    const label = moment(year + '-' + month + '-' + day).format("dddd DD MMMM")
    const date = new Date(year, month-1, day)
    return {day, month, year, hour, order, label, date};
  }

  static parseTeam(team) {
    const value = _.replace(_.replace(team, /\s/g, '-'), /[\n\r]/g, '')
    const asspm = _.includes(value, "PIERRE-MON") || _.includes(value, "MONTREV") || _.includes(value, "ENT.ST") ? "ASSPM" : team;
    if (_.isNil(asspm) || asspm == "undefined") {
      console.warn(team, value, asspm)
    }
    return asspm;
  }

  //static parseResult(type, html, filter = "") {
  static parseResult(type, html, read) {
    //debugger
    console.log("EventService", "parseResult", type, read)
    const doc = this.parser.parseFromString(html, "text/html");
    //const query = doc.body.querySelectorAll(`${filter} .confrontation`)
    const query = doc.body.querySelectorAll(`.confrontation`)
    //console.log(query)
    if (query.length > 30) return Promise.resolve([])
    const promises = _.map(query, c => {
      const conf = this.parser.parseFromString(c.innerHTML, "text/html");
      const dateText = _.first(_.split(this.getHtml(conf, ".date"), "<!--"))
      const dateInfo = this.parseDate(_.last(dateText.split("<br>")).trim())
      const date = dateInfo.day + '-' + dateInfo.month + '-' + dateInfo.year
      const order = "" + dateInfo.year + dateInfo.month + dateInfo.day
      const team1 = this.getText(conf, ".equipe1 .name")
      const eq1 = this.parseTeam(team1)
      const logo1 = this.getDataSrc(conf, ".equipe1 .logo img")
      const team2 = this.getText(conf, ".equipe2 .name")
      const eq2 = this.parseTeam(team2)
      const logo2 = this.getDataSrc(conf, ".equipe2 .logo img")
      //const score = this.getText(conf, ".score_match")
      const scoreUrl1 = this.getSrc(conf, ".score_match img", 0)
      const scoreUrl2 = this.getSrc(conf, ".score_match img", 1)
      let event = this.getHtml(conf, ".date .competition").replace(/<br>/g, ' ');
      if (_.isEmpty(event)) {
        event = _.last(this.getHtml(conf, ".date").split("<br>"));
      }
      const eventKey = _.kebabCase(event);
      let competition = _.get(this.EVENTS, eventKey, eventKey)
      const logo = _.get(this.LOGOS, competition, "")
      //console.log(dateInfo, eq1, logo1, eq2, logo2, scoreUrl1, scoreUrl2, competition)
      const styl1 = eq1 == "ASSPM" ? "color" : ""
      const styl2 = eq2 == "ASSPM" ? "color" : ""
      if (_.isNil(eq1) || eq1 == "undefined") {
        //debugger;
      }
      return this.getScore(scoreUrl1, scoreUrl2).then(scores => {
        return {date, dateInfo, eq1, logo1, eq2, logo2, score1: scores.score1, score2: scores.score2, competition, event, logo, order, styl1, styl2, team1, team2}
      })
    })
    return Promise.all(promises)
  }
  
  static getScore(scoreUrl1, scoreUrl2) {

    const score1 = _.first(_.split(_.last(_.split(scoreUrl1, "/")), "."))
    const score2 = _.first(_.split(_.last(_.split(scoreUrl2, "/")), "."))
    return Promise.resolve({score1, score2})

    //const getScore = scoreUrl1 ? Promise.resolve([axios.get(this.COLORAT + scoreUrl1), axios.get(this.COLORAT + scoreUrl2)]).spread((scoreRes1, scoreRes2) => {
    if (_.isEmpty(scoreUrl1)) return Promise.resolve({score1: 0, score2: 0})
    const p1 = HttpService.get(this.COLORAT + scoreUrl1);
    const p2 = HttpService.get(this.COLORAT + scoreUrl2);
    const getScore = Promise.resolve([p1, p2]).spread((scoreRes1, scoreRes2) => {
      const mesh1 = JSON.stringify(scoreRes1.data)
      const mesh2 = JSON.stringify(scoreRes2.data)
      const score1 = _.find(this._numbers, n => JSON.stringify(n.mesh) === mesh1).number
      const score2 = _.find(this._numbers, n => JSON.stringify(n.mesh) === mesh2).number
      return {score1, score2}
    })
    return getScore;
  }

  static getText(doc, query) {
    return _.get(doc.body.querySelectorAll(query), "0.innerText", "").trim()
  }

  static getHtml(doc, query) {
    return _.get(doc.body.querySelectorAll(query), "0.innerHTML", "").trim()
  }

  static getSrc(doc, query, index = 0) {
    const el = doc.body.querySelectorAll(query)
    return _.get(el, `${index}.src`, "").trim()
  }

  static getDataSrc(doc, query, index = 0) {
    //console.log("getDataSrc")
    const el = Array.from(doc.body.querySelectorAll(query))
    //return _.get(el, `${index}.attributes.0.value`, "").trim()
    return el[0] && el[0].src
  }


}

export default EventService

export {EventService}